import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-feda3db6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "other-select" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_input = _resolveComponent("ui-input")!
  const _component_ui_tip = _resolveComponent("ui-tip")!
  const _component_ui_group_option = _resolveComponent("ui-group-option")!
  const _component_ui_group = _resolveComponent("ui-group")!

  return (_openBlock(), _createBlock(_component_ui_group, {
    title: $props.hideTitle ? '' : _ctx.$t('coord.selectType')
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "first", {}, undefined, true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.coordTypes, (coordType, key) => {
        return (_openBlock(), _createElementBlock(_Fragment, null, [
          (`${key}` !== `${$props.disabled}`)
            ? (_openBlock(), _createBlock(_component_ui_group_option, {
                key: 0,
                class: _normalizeClass({ disabled: $props.disShow && $props.disShow.includes(key) })
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ui_input, {
                    type: "radio",
                    label: coordType.label,
                    modelValue: $props.type === key,
                    "onUpdate:modelValue": ($event: any) => ($setup.emit('update:type', key))
                  }, null, 8 /* PROPS */, ["label", "modelValue", "onUpdate:modelValue"]),
                  _createVNode(_component_ui_tip, {
                    tip: 
            coordType.options.value.find(({ value }) => $setup.selects[key] === value)
              ?.label
          
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, [
                        _createVNode(_component_ui_input, {
                          disabled: $props.type !== key,
                          placeholder: _ctx.$t('sys.selectPic'),
                          type: "search",
                          unplaceholder: _ctx.$t('sys.unData'),
                          options: coordType.options.value,
                          modelValue: $setup.selects[key],
                          "onUpdate:modelValue": ($event: any) => (($setup.selects[key]) = $event),
                          width: "100%"
                        }, null, 8 /* PROPS */, ["disabled", "placeholder", "unplaceholder", "options", "modelValue", "onUpdate:modelValue"]),
                        _renderSlot(_ctx.$slots, "append", {
                          type: key,
                          disabled: $props.type !== key
                        }, undefined, true)
                      ])
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["tip"])
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["class"]))
            : _createCommentVNode("v-if", true)
        ], 64 /* STABLE_FRAGMENT */))
      }), 256 /* UNKEYED_FRAGMENT */)),
      _renderSlot(_ctx.$slots, "default", {}, undefined, true),
      _renderSlot(_ctx.$slots, "last", {}, undefined, true)
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["title"]))
}